import { compare, valid } from 'semver';

export function normalizeStrictSemver(version: string): string | null {
  const normalized = version.trim();
  return valid(normalized) === normalized ? normalized : null;
}

export function isStrictSemver(version: string): boolean {
  return normalizeStrictSemver(version) !== null;
}

export function compareStrictSemver(
  leftVersion: string,
  rightVersion: string
): number | null {
  const left = normalizeStrictSemver(leftVersion);
  const right = normalizeStrictSemver(rightVersion);

  if (!left || !right) {
    return null;
  }

  return compare(left, right);
}

export function isVersionHigherThanPublished(
  candidate: string,
  latestPublishedVersion: string | null | undefined
): boolean {
  if (!latestPublishedVersion) {
    return isStrictSemver(candidate);
  }

  const comparison = compareStrictSemver(candidate, latestPublishedVersion);
  return comparison !== null && comparison > 0;
}
